import { combineReducers } from 'redux';
const masterInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    tab: 'all',
    keyword: '',
    size: 20,
  },
};

function weibanReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'WEIBAN_PHONE': {
      const { data, error } = action;
      if (error) {
        return state
      }

      return {
        ...state,
      }
    }
    case "WEIBAN_PHONE_COMPELTION": {
      const { data, error } = action;
      if (error) {
        return {
          ...state,
        };
      }

      return {
        ...state,
        checkphone: !data,
        jumpLink: data
      }
    }
    case "WEIBAN_PHONE_CHECK": {
      const { value, jumpLink } = action;
      return {
        ...state,
        checkphone: value,
        jumpLink: jumpLink ?? false
      }
    }
    case "WEIBAN_ORDER": {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }
      return {
        ...state,
        loadStatus: 1,
        query: {
          tab: 'order',
          ...state.query,
          ...action.query
        },
        list: null,
      }
    }
    case "WEIBAN_ORDER_COMPELTION": {
      const { data, error } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };

      }
      const list = data.onlineList
      return {
        ...state,
        orderCounts: {
          money: data?.money ?? 0,
          orderNum: data?.orderNum ?? 0,
          onlineCount: data?.onlineCount ?? 0,
        },
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      }
    }


    case "WEIBAN_ORDER_DETAIL": {
      const { data, error } = action;
      if (error) {
        return state
      }

      return {
        ...state,
        ...action.query
      }
    }
    case "WEIBAN_ORDER_DETAIL_COMPELTION": {
      const { data, error } = action;
      if (error) {
        return state
      }
      return {
        ...state,
        wborderDetail: data
      }
    }
    default:
      return state;
  }
}
function weibanStoreReducer(state = masterInitialState, action) {
  switch (action.type) {
    case "WEIBAN_STORE_ORDER": {

      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }
      return {
        ...state,
        loadStatus: 1,
        query: {
          tab: 'store',
          ...state.query,
          ...action.query
        },
        list: null,
      }
    }
    case "WEIBAN_STORE_ORDER_COMPELTION": {
      const { data, error } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };

      }
      const list = data.ljOrderListVo

      return {
        ...state,
        orderCounts: {
          offlineCount: data?.offlineCount ?? 0,
          storeSalseCount: data?.storeSalseCount ?? 0,
          storeSalseSum: data?.storeSalseSum ?? 0
        },
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      }
    }

    default:
      return state;
  }
}
export default combineReducers({
  weiban: weibanReducer,
  weibanstore: weibanStoreReducer
})